export const TEXT = {
  ar: {
    title: "طلبات تهيئة المتجر",
    description: "متابعة جميع بيانات التهيئة حسب المراحل",
    managePipeline: "إدارة طلبات التهيئة",
    search: "بحث",
    searchPlaceholder: "اسم المتجر أو المالك",
    city: "المدينة",
    cityPlaceholder: "مثال: جدة",
    status: "الحالة",
    package: "الباقة",
    all: "الكل",
    draft: "مسودة",
    submitted: "مرسل",
    approved: "معتمد",
    rejected: "مرفوض",
    invoice_issued: "اصدار فاتورة",
  quotation_pending: "بانتظار عرض السعر",
    quotation_rejected: "عرض السعر مرفوض",
    subscription_quote_pending: "بانتظار عرض سعر الاشتراك",
    subscription_quote_rejected: "عرض سعر الاشتراك مرفوض",
    completed: "مكتمل",
    store: "المتجر",
    created: "التاريخ",
    view: "عرض",
    close: "إغلاق",
    approve: "اعتماد",
    reject: "رفض",
    loading: "جاري التحميل...",
    noData: "لا توجد بيانات",
    currentStage: "المرحلة الحالية",
    requestStatus: "حالة الطلب",
    submittedAt: "تاريخ الإرسال",
    approvedAt: "تاريخ الاعتماد",
    rejectionReason: "سبب الرفض",
    stage1: "المرحلة الأولى",
    stage1Desc: "بيانات المتجر، التواصل، الكيان، المستندات الأساسية والشروط",
    stage2: "المرحلة الثانية",
    stage2Desc: "عرض السعر الأول وإجراءات الدفع",
    stage3: "المرحلة الثالثة",
    stage3Desc: "الفروع وبيانات القائمة وتطبيقات التوصيل والحملات",
    stage4: "المرحلة الرابعة",
    stage4Desc: "الربط والتكامل ومستندات التطبيقات الجديدة",
    stage5: "المرحلة الخامسة",
    stage5Desc: "الباقة و عرض سعر الاشتراك والتفعيل",
    workflowDesc: "حالة الطلب وسجل الإجراءات لجميع المراحل",
    packageInfo: "بيانات الباقة",
    storeInfo: "بيانات المتجر",
    contactInfo: "بيانات التواصل",
    entityInfo: "بيانات الكيان",
    branches: "الفروع",
    deliveryApps: "تطبيقات التوصيل",
    menuInfo: "بيانات قائمة الطعام",
    campaigns: "الحملات",
    integration: "الربط والتكامل",
    newApps: "التطبيقات الجديدة",
    updates: "التحديثات المطلوبة",
    documents: "المستندات",
    summary: "الملخص المالي",
    terms: "الشروط",
    workflow: "سير العمل",
    yes: "نعم",
    no: "لا",
    notSelected: "غير محدد",
    file: "ملف",
    openFile: "فتح الملف",
    history: "سجل الإجراءات",
    quotation: "عرض السعر",
    updateQuotation: "تحديث عرض السعر",
    ludPrice: "تكلفة خدمة LUD",
    discountCode: "كود الخصم",
    quoteType: "نوع كود الخصم",
    initialQuote: "عرض السعر الأول",
    subscriptionQuote: "عرض سعر الاشتراك",
    initial: "عرض السعر الأول",
    subscription: "عرض سعر الاشتراك",
    discountPercent: "نسبة الخصم",
    discountAmount: "قيمة الخصم",
    finalPrice: "الإجمالي بعد الخصم",
    receipt: "الإيصال",
    discountCodesTitle: "إدارة أكواد الخصم",
    discountCodesDescription: "الأكواد الفعالة يقدر العميل يدخلها في عرض السعر وتطبق على خدمة LUD فقط",
    saveDiscountCode: "حفظ كود الخصم",
    saving: "جاري الحفظ...",
    active: "فعال",
    inactive: "غير فعال",
    activate: "تفعيل",
    deactivate: "إيقاف",
    maxUses: "عدد الاستخدامات",
    aiPhotosAddon: "إضافة صور AI",
    aiPhotosCount: "عدد صور AI",
    aiPhotosConfirm: "هل تريد تفعيل إضافة صور AI؟",
    addonPrice: "تكلفة الإضافة",
    transferInfo: "بيانات التحويل",
    rejectStage1: "رفض 1",
    rejectStage2: "رفض 2",
    rejectStage3: "رفض 3",
    rejectStage4: "رفض 4",
    rejectStage5: "رفض 5",
  },
  en: {
    title: "Store Onboarding Requests",
    description: "Review all onboarding data organized by stages",
    managePipeline: "Manage onboarding pipeline",
    search: "Search",
    searchPlaceholder: "Store or owner name",
    city: "City",
    cityPlaceholder: "Example: Jeddah",
    status: "Status",
    package: "Package",
    all: "All",
    draft: "Draft",
    submitted: "Submitted",
    approved: "Approved",
    invoice_issued: "Invoice Issued",
    rejected: "Rejected",
    quotation_pending: "Quotation Pending",
    quotation_rejected: "Quotation Rejected",
    subscription_quote_pending: "Subscription Quotation Pending",
    subscription_quote_rejected: "Subscription Quotation Rejected",
    completed: "Completed",
    store: "Store",
    created: "Created",
    view: "View",
    close: "Close",
    approve: "Approve",
    reject: "Reject",
    loading: "Loading...",
    noData: "No data",
    currentStage: "Current Stage",
    requestStatus: "Request Status",
    submittedAt: "Submitted At",
    approvedAt: "Approved At",
    rejectionReason: "Rejection Reason",
    stage1: "Stage 1",
    stage1Desc: "Store, contact, entity, basic documents, and terms",
    stage2: "Stage 2",
    stage2Desc: "Initial quotation and payment actions",
    stage3: "Stage 3",
    stage3Desc: "Branches, menu data, delivery apps, and campaigns",
    stage4: "Stage 4",
    stage4Desc: "Integration and new-app documents",
    stage5: "Stage 5",
    stage5Desc: "Package, subscription quotation, and activation",
    workflowDesc: "Request status and action history across all stages",
    packageInfo: "Package Info",
    storeInfo: "Store Info",
    contactInfo: "Contact Info",
    entityInfo: "Entity Info",
    branches: "Branches",
    deliveryApps: "Delivery Apps",
    menuInfo: "Menu Info",
    campaigns: "Campaigns",
    integration: "Integration",
    newApps: "New Apps",
    updates: "Requested Updates",
    documents: "Documents",
    summary: "Financial Summary",
    terms: "Terms",
    workflow: "Workflow",
    yes: "Yes",
    no: "No",
    notSelected: "Not selected",
    file: "File",
    openFile: "Open file",
    history: "Action History",
    quotation: "Quotation",
    updateQuotation: "Update Quotation",
    ludPrice: "LUD Service Cost",
    discountCode: "Discount Code",
    quoteType: "Discount Code Type",
    initialQuote: "Initial Quotation",
    subscriptionQuote: "Subscription Quotation",
    initial: "Initial Quotation",
    subscription: "Subscription Quotation",
    discountPercent: "Discount Percent",
    discountAmount: "Discount Amount",
    finalPrice: "Total After Discount",
    receipt: "Receipt",
    discountCodesTitle: "Discount Codes Management",
    discountCodesDescription: "Active codes can be entered by the customer in the quotation and apply only to the LUD service",
    saveDiscountCode: "Save Discount Code",
    saving: "Saving...",
    active: "Active",
    inactive: "Inactive",
    activate: "Activate",
    deactivate: "Deactivate",
    maxUses: "Max Uses",
    aiPhotosAddon: "AI Photos Add-on",
    aiPhotosCount: "AI Photos Count",
    aiPhotosConfirm: "Enable AI photos add-on?",
    addonPrice: "Add-on Cost",
    transferInfo: "Transfer Information",
    rejectStage1: "Reject 1",
    rejectStage2: "Reject 2",
    rejectStage3: "Reject 3",
    rejectStage4: "Reject 4",
    rejectStage5: "Reject 5",
  },
};

// Same list as the client flow's workflow statuses (backend enum).
export { WORKFLOW_STATUSES as STATUS_OPTIONS } from "../../onboarding";
